import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Handle Vite dynamic import chunk failures after new deployments
window.addEventListener('vite:preloadError', (event) => {
  console.warn('[Vite] Preload error detected for chunk. Refreshing to get latest build assets...', event)
  const lastReload = sessionStorage.getItem('nttd_preload_reload')
  const now = Date.now()
  if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
    sessionStorage.setItem('nttd_preload_reload', now.toString())
    window.location.reload()
  }
})

// Apply initial theme before render to prevent flash
const savedTheme = JSON.parse(localStorage.getItem('nttd-theme') ?? '{"state":{"theme":"dark"}}')
const theme = savedTheme?.state?.theme ?? 'dark'
const resolved = theme === 'system'
  ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
  : theme
document.documentElement.setAttribute('data-theme', resolved)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
